import React, { Component } from "react";
import { Link, NavLink } from "react-router-dom";
import { getCurrentUser } from "./../services/authService";

class NavBar extends Component {
  constructor(props) {
    super(props);
    this.toggleNavbar = this.toggleNavbar.bind(this);
    this.state = {
      collapsed: true
    };
  }

  toggleNavbar() {
    this.setState({
      collapsed: !this.state.collapsed
    });
  }

  render() {
    const user = getCurrentUser();
    const collapsed = this.state.collapsed;
    const classOne = collapsed
      ? "collapse navbar-collapse"
      : "collapse navbar-collapse show";

    const classTwo = collapsed
      ? "navbar-toggler navbar-toggler-right collapsed"
      : "navbar-toggler navbar-toggler-right";

    return (
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark transparent-nav">
        <div className="container">
          <Link className="navbar-brand" to="/match-bets">
            betView
          </Link>
          <button
            onClick={this.toggleNavbar}
            className={`${classTwo}`}
            type="button"
            data-toggle="collapse"
            data-target="#navbarResponsive"
            aria-controls="navbarResponsive"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon" />
          </button>
          <div className={`${classOne + " navbar-nav"}`} id="navbarResponsive">
            {user && user.isAdmin && (
              <React.Fragment>
                {" "}
                <NavLink className="nav-item nav-link" to="/users">
                  Users
                </NavLink>
                <NavLink className="nav-item nav-link" to="/leagues">
                  Leagues
                </NavLink>
                <NavLink className="nav-item nav-link" to="/seasons">
                  Seasons
                </NavLink>
                <NavLink className="nav-item nav-link" to="/matchdays">
                  Match Days
                </NavLink>
                <NavLink className="nav-item nav-link" to="/teams">
                  Teams
                </NavLink>
                <NavLink className="nav-item nav-link" to="/matches">
                  Matches
                </NavLink>
              </React.Fragment>
            )}
            {!user && (
              <NavLink className="nav-item nav-link" to="/login">
                Login
              </NavLink>
            )}{" "}
            {user && (
              <React.Fragment>
                <NavLink className="nav-item nav-link" to="/match-bets">
                  Match Bets
                </NavLink>
                <NavLink className="nav-item nav-link" to="/ranking">
                  Ranking
                </NavLink>
                <NavLink className="nav-item nav-link" to="/hall-of-fame">
                  Hall Of Fame
                </NavLink>
                <NavLink className="nav-item nav-link" to="/stats">
                  Stats
                </NavLink>
                <NavLink className="nav-item nav-link" to="/profile">
                  {user.name}
                </NavLink>
                <NavLink className="nav-item nav-link" to="/logout">
                  Logout
                </NavLink>
              </React.Fragment>
            )}
          </div>
        </div>
      </nav>
    );
  }
}
export default NavBar;



// WEBPACK FOOTER //
// ./src/components/navBar.jsx